<template>
  <div class="pricemonitoring-page">
    <PageSellerCharts />
    <PageSellerTable />
  </div>
</template>

<script>
import PageSellerCharts from '@/components/Seller/PageSellerCharts.vue'
import PageSellerTable from '@/components/Seller/PageSellerTable.vue'
export default {
  components:{
    PageSellerCharts,
    PageSellerTable
  },

}
</script>
